import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {AccountModel} from "../../domain/models/account.model";
import {AddressInfoCardComponent} from "../address-info-card/address-info-card.component";
import {CurrencyInputDirective} from "../../utils/directives/currency-input.directive";
import {MatButton} from "@angular/material/button";
import {MatDivider} from "@angular/material/divider";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {MatOption} from "@angular/material/core";
import {MatSelect} from "@angular/material/select";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {StatusIndicatorComponent} from "../status-indicator/status-indicator.component";
import {MatCard} from "@angular/material/card";
import {MatCheckbox} from "@angular/material/checkbox";
import {LicensesComponent} from "../licenses/licenses.component";
import {
  CustomerFormComponent
} from "../../pages/search/customer/search-customer-detail/components/customer-form-component";
import {Icons} from "../../domain/enums/icons-enums";
import {NgIf} from "@angular/common";
import {FormValidationUtil} from "../../utils/form-validation.util";

@Component({
  selector: 'app-account-bed-profile',
  standalone: true,
  imports: [
    AddressInfoCardComponent,
    CurrencyInputDirective,
    MatButton,
    MatDivider,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatOption,
    MatSelect,
    ReactiveFormsModule,
    StatusIndicatorComponent,
    MatCard,
    MatCheckbox,
    LicensesComponent,
    MatError,
    NgIf
  ],
  templateUrl: './account-bed-profile.component.html',
  styleUrl: './account-bed-profile.component.css'
})
export class AccountBedProfileComponent implements OnInit, CustomerFormComponent, OnChanges {
  @Input() account!: AccountModel;
  @ViewChild(AddressInfoCardComponent) addressInfo!: AddressInfoCardComponent;
  @ViewChild(LicensesComponent) licenses!: LicensesComponent;
  contactInfoForm!: FormGroup;
  protected readonly icons = Icons;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    console.log("AccountBedProfileComponent.account", this.account);
    this.buildForm(this.account);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.buildForm(this.account);
  }

  buildForm(info: AccountModel): void {
    this.contactInfoForm = this.fb.group({
      companyName: [info?.companyName?? '', Validators.required],
      webSiteUrl: [info?.webSiteUrl?? '', [
        Validators.pattern(FormValidationUtil.getUrlValidationPattern())]],
      eSignature: [{value:info?.printedName?? '', disabled:true}],
      status: [info?.status ?? '', Validators.required],
      billingFreq: [ info?.frequency, Validators.required],
      credit: [info?.credit ?? 0, [Validators.required,
        Validators.pattern(FormValidationUtil.getCurrencyValidationPattern())]],
      primaryContactFirstName: [ info?.primaryContactFirstName, Validators.required],
      primaryContactLastName: [ info?.primaryContactLastName, Validators.required],
      primaryContactEmail: [ info?.primaryContactEmail, Validators.required],
      primaryContactPhoneNumber: [ info?.primaryContactPhoneNumber, [Validators.required,
        Validators.pattern(FormValidationUtil.getPhoneValidationPattern())]],
    });
  }

  getContactInfoForm(): AccountModel {
    const formData = this.contactInfoForm.value;

    // This form has companyName, not the businessLegalName/businessDbaName pair the
    // management-company profile uses. Returning those two anyway produced undefined keys
    // that getUpdatedAccount() then spread over the loaded account, wiping both fields on
    // save, while an edit to companyName was dropped because it was never returned.
    return {
      companyName: formData.companyName,
      webSiteUrl: formData.webSiteUrl,
      status: formData.status,
      frequency: formData.billingFreq,
      credit: formData.credit,
      primaryContactFirstName: formData.primaryContactFirstName,
      primaryContactLastName: formData.primaryContactLastName,
      primaryContactEmail: formData.primaryContactEmail,
      primaryContactPhoneNumber: formData.primaryContactPhoneNumber
    };
  }

  getUpdatedAccount(): AccountModel {
    return {
      ...this.account,
      ...this.getContactInfoForm(),
      ...this.addressInfo.getAddressInfoFromForm(),
      entityLicense: this.licenses.getUpdatedLicense()
    };
  }

  isFormValid(): boolean {
    return this.contactInfoForm.valid &&
      this.addressInfo.isFormValid() &&
      this.licenses.isFormValid();
  }

  raiseFormValidations(): void {
    this.contactInfoForm.markAllAsTouched();
    this.addressInfo.raiseFormValidations();
    this.licenses.raiseFormValidations();
  }

}
